<template>
    <v-tooltip :text="text" :location="location ?? 'bottom center'">
        <template v-slot:activator="{ props }">
            <div v-bind="props">
                <slot></slot>
            </div>
        </template>
    </v-tooltip>
</template>
<script>
export default {
    props: ['text','location'],
}
</script>
